<template>
  <div class="checkbox-group">
    <div
      v-for="(checkbox, index) in checkboxList"
      :key="`${checkbox.name}_${index}`"
    >
      <base-checkbox
        :label="checkbox.label"
        :name="checkbox.name"
        :value="checkbox.value"
        v-model="selectedItems[checkbox.name]"
        @update-value="changeHandler"
      ></base-checkbox>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import BaseCheckbox from './BaseCheckbox.vue';
import { E_CHECKBOX_GROUP_MODE } from '../../types/components.enums';
import { E_CHECKBOX_GROUP_EVENT } from '../../types/components-events.enums';
import type { ICheckbox, ISelectedCheckbox } from '../../types/checkbox.types';
import type { TCheckboxGroupEventResponse } from '../../types/event-response.types';
import type { TCheckboxGroupSelectedItems } from '../../types/checkbox-group.types';

interface IProps {
  mode?: E_CHECKBOX_GROUP_MODE;
  checkboxList: ICheckbox[];
};
const props = defineProps<IProps>();
const emit = defineEmits<{
  (event: E_CHECKBOX_GROUP_EVENT.CHANGE, value: TCheckboxGroupEventResponse[E_CHECKBOX_GROUP_EVENT.CHANGE]): void;
}>();

const selectedItems = ref<TCheckboxGroupSelectedItems>({});

function changeHandler(item: ISelectedCheckbox) {
  if (props.mode === E_CHECKBOX_GROUP_MODE.SINGLE) {
    singleMode(item);
  }
  emit(E_CHECKBOX_GROUP_EVENT.CHANGE, selectedItems.value);
}

function singleMode(item: ISelectedCheckbox) {
  const restItems = Object.entries(selectedItems.value).filter(([key]) => key !== item.name);
  restItems.forEach(([key, value]) => {
    if (value) {
      selectedItems.value[key] = false;
    }
  });
}

onMounted(() => {
  if (props.checkboxList?.length) {
    selectedItems.value = Object.fromEntries(
      props.checkboxList.map((item) => [item.name, item.value])
    );
  }
})
</script>

<style scoped lang="scss">
.checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
</style>